<template>
  <section
    v-if="shopifyData.checkSection == 'true'"
    :id="'blog_video_sec_' + shopifyData.nameOfPage"
    :class="shopifyData.nameOfPage"
    class="video_sec blog_video_sec"
    :style="{ backgroundColor: backgroundColor }"
  >
    <!-- Sec Head -->
    <div v-if="shopifyData.SectionShow == 'true'" class="sec_head">
      <h2
        class="main_heading"
        :style="{
          fontSize: sectionHeadingSize,
          textAlign: sectionHeadingAlign,
          width: sectionHeadingWidth,
          color: sectionHeadingColor,
        }"
        v-html="shopifyData.SecHeading"
      />
    </div>
    <!-- Sec Content -->
    <div
      v-if="shopifyData.VideoShow === 'true'"
      class="sec_content bg-black"
      :style="{
        backgroundColor: videoBackgroundColor,
        paddingTop: paddingTopVideo,
        paddingBottom: paddingBottomVideo,
        paddingLeft: paddingLeftRightVideo,
        paddingRight: paddingLeftRightVideo,
      }"
    >
      <div class="sec_video modify-slider">
        <div class="tmb_blog_slider_image">
          <div v-if="shopifyData.CheckVideoImage == 'false'">
            <!-- <video
              class="subtitle"
              autoplay="true"
              loop="true"
              muted="true"
              controlsList="nodownload"
              disablepictureinpicture
              webkit-playsinline="true"
              playsinline="true"
              preload="none"
              @click="toggle_selection_for(key)"
            >
              <source :src="shopifyData.videolink" />
            </video> -->

            <div class="video_wrapper">
              <video
                ref="videoEl"
                class="subtitle"
                autoplay
                loop
                muted
                controlsList="nodownload"
                disablepictureinpicture
                playsinline
                webkit-playsinline
                preload="auto"
              >
                <source :src="shopifyData.videolink" />
              </video>

              <!-- Mute/Unmute Button -->
              <button class="mute_btn" @click="toggleMute">
                <!-- Mute icon -->
                <span v-if="isMuted">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 32 32"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M15.8206 5.41065C16.3921 5.64738 16.7647 6.20506 16.7647 6.82365V25.1766C16.7647 25.7952 16.3921 26.3529 15.8206 26.5896C15.2491 26.8263 14.5912 26.6955 14.1538 26.258L8.48414 20.5884H4.52941C3.68474 20.5884 3 19.9036 3 19.0589V12.9413C3 12.0966 3.68474 11.4119 4.52941 11.4119H8.48414L14.1538 5.74219C14.5912 5.30478 15.2491 5.17393 15.8206 5.41065Z"
                      fill="white"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M20.2715 11.8598C20.8688 11.2625 21.8371 11.2625 22.4344 11.8598L24.4118 13.8372L26.3891 11.8598C26.9864 11.2625 27.9548 11.2625 28.552 11.8598C29.1493 12.4571 29.1493 13.4254 28.552 14.0227L26.5747 16.0001L28.552 17.9774C29.1493 18.5747 29.1493 19.5431 28.552 20.1404C27.9548 20.7376 26.9864 20.7376 26.3891 20.1404L24.4118 18.163L22.4344 20.1404C21.8371 20.7376 20.8688 20.7376 20.2715 20.1404C19.6742 19.5431 19.6742 18.5747 20.2715 17.9774L22.2489 16.0001L20.2715 14.0227C19.6742 13.4254 19.6742 12.4571 20.2715 11.8598Z"
                      fill="white"
                    />
                  </svg>
                </span>

                <!-- Unmute icon -->
                <span v-else>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 32 32"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M15.1083 5.99907C15.6481 6.22265 16 6.74934 16 7.33357V24.6669C16 25.2511 15.6481 25.7778 15.1083 26.0014C14.5686 26.225 13.9473 26.1014 13.5342 25.6883L8.17947 20.3336H4.44445C3.6467 20.3336 3 19.6869 3 18.8891V13.1113C3 12.3136 3.6467 11.6669 4.44445 11.6669H8.17947L13.5342 6.31219C13.9473 5.89908 14.5686 5.7755 15.1083 5.99907Z"
                      fill="white"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M22.7266 5.78635C23.2907 5.22226 24.2052 5.22226 24.7693 5.78635C27.3817 8.3987 29 12.0118 29 16.0001C29 19.9884 27.3817 23.6015 24.7693 26.2139C24.2052 26.778 23.2907 26.778 22.7266 26.2139C22.1625 25.6498 22.1625 24.7352 22.7266 24.1711C24.8193 22.0784 26.1111 19.1915 26.1111 16.0001C26.1111 12.8087 24.8193 9.92183 22.7266 7.8291C22.1625 7.26501 22.1625 6.35044 22.7266 5.78635ZM18.6411 9.87186C19.2051 9.30777 20.1197 9.30777 20.6838 9.87186C21.4434 10.6315 22.0633 11.5323 22.5004 12.5329C22.9652 13.5965 23.2222 14.7702 23.2222 16.0001C23.2222 18.393 22.2506 20.5616 20.6838 22.1284C20.1197 22.6925 19.2051 22.6925 18.6411 22.1284C18.077 21.5643 18.077 20.6497 18.6411 20.0856C19.6882 19.0385 20.3333 17.596 20.3333 16.0001C20.3333 15.1757 20.1615 14.3953 19.8532 13.6895C19.5624 13.024 19.1491 12.4227 18.6411 11.9146C18.077 11.3505 18.077 10.4359 18.6411 9.87186Z"
                      fill="white"
                    />
                  </svg>
                </span>
              </button>
            </div>
          </div>
          <div v-if="shopifyData.CheckVideoImage == 'true'" class="sec_image_slider">
            <div class="sec_content modify-slider" @click="toggle_selection_for(key)">
              <swiper
                :effect="'fade'"
                :modules="modules"
                :centered-slides="true"
                :space-between="100"
                :loop="true"
                class="mySwiper"
              >
                <swiper-slide v-for="(value, key) in shopifyData.SliderImagesData" :key="key">
                  <img
                    v-lazy="value.SliderImage.src"
                    :src-placeholder="value.SliderImage.placeholder"
                    :alt="value.SliderImage.alt"
                    loading="lazy"
                    aria-hidden="true"
                    aria-label="Video Section Image"
                    width=""
                    height=""
                  />
                </swiper-slide>
              </swiper>
            </div>
          </div>
          <swiper
            v-if="hasProducts"
            :class="{ active: isactive.includes(key) }"
            class="product_info_card"
            :modules="modules"
            :loop="true"
            :slides-per-view="'1'"
            :mousewheel="{ invert: false, releaseOnEdges: true }"
            :navigation="true"
          >
            <swiper-slide v-for="(product, index) in shopifyData.productData" :key="index">
              <productPopup :product-data="product" @close="toggle_selection_for(key)" />
            </swiper-slide>
          </swiper>
        </div>
        <div v-if="shopifyData.secCta" class="shop_cta">
          <button
            class="subtitle"
            aria-label="Shop CTA"
            @click="toggle_selection_for(key)"
            v-html="shopifyData.secCta"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
// Producct Popup Component Import
import productPopup from '../product-popup.vue';

// Slider Import
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Autoplay, EffectFade } from 'swiper';
import 'swiper/css';
export default {
  components: {
    productPopup,
    Swiper,
    SwiperSlide,
  },
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },

  setup() {
    return {
      modules: [Navigation, Autoplay, EffectFade],
    };
  },
  data() {
    window.addEventListener('scroll', () => {
      if (document.querySelector('.video_sec')) {
        const VideoSection = document.querySelector('.video_sec');
        VideoSection.getBoundingClientRect();
        if (VideoSection.getBoundingClientRect().top < 0) {
          VideoSection.classList.add('active');
          // document.body.classList.add("active-Bg");
        } else {
          VideoSection.classList.remove('active');
          // document.body.classList.remove("active-Bg");
        }
      }
    });
    return {
      windowWidth: window.innerWidth,
      isactive: [],
      isMuted: true,
      observer: null,
    };
  },
  computed: {
    hasProducts() {
      return this.shopifyData?.productData?.length > 0;
    },
    backgroundColor() {
      return window.innerWidth <= 768
        ? this.shopifyData.sectionColorMob
        : this.shopifyData.sectionColorDesktop;
    },
    videoBackgroundColor() {
      return window.innerWidth <= 768
        ? this.shopifyData.videoColorMob
        : this.shopifyData.videoColorDesktop;
    },
    sectionHeadingSize() {
      return window.innerWidth <= 768
        ? this.shopifyData.SecHeadingSizeMobile + 'px'
        : this.shopifyData.SecHeadingSize + 'px';
    },
    sectionHeadingAlign() {
      return window.innerWidth <= 768
        ? this.shopifyData.SecHeadingAlignMobile
        : this.shopifyData.SecHeadingAlign;
    },
    sectionHeadingWidth() {
      return window.innerWidth <= 768 ? 100 + '%' : this.shopifyData.SecHeadingWidth + '%';
    },
    sectionHeadingColor() {
      return this.shopifyData.SectionHeadingColor || '#FF0000';
    },

    paddingTopVideo() {
      return window.innerWidth <= 768
        ? this.shopifyData.paddingTopVideoMob + 'px'
        : this.shopifyData.paddingTopVideoDesktop + 'px';
    },
    paddingBottomVideo() {
      return window.innerWidth <= 768
        ? this.shopifyData.paddingBottomVideoMob + 'px'
        : this.shopifyData.paddingBottomVideoDesktop + 'px';
    },
    paddingLeftRightVideo() {
      return window.innerWidth <= 768
        ? this.shopifyData.paddingLeftRightVideoMob + 'px'
        : this.shopifyData.paddingLeftRightVideoDesktop + 'px';
    },
  },
  mounted() {
    const video = this.$refs.videoEl;
    if (!video) return;

    video.muted = true;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.6 }
    );

    this.observer.observe(video);
  },

  beforeUnmount() {
    if (this.observer) this.observer.disconnect();
  },

  methods: {
    toggle_selection_for(key) {
      if (window.innerWidth <= 768) {
        if (this.isactive.includes(key)) {
          this.isactive = this.isactive.filter((item) => item !== key);
        } else {
          this.isactive.push(key);
        }
      }
    },
    toggleMute() {
      const video = this.$refs.videoEl;

      video.muted = !video.muted;
      this.isMuted = video.muted;

      video.play().catch(() => {});
    },
  },
};
</script>

<style scoped>
.product_info_card {
  position: absolute !important;
  width: 240px;
  height: 340px;
}

/* .video_sec.active .sec_content.bg-black {
	background: #000;
} */

/* Hover Show Product Cart Css */
.sec_video.modify-slider > .product_info_card {
  transform: translateX(-100%);
}

.sec_video.modify-slider {
  overflow: hidden;
  cursor: pointer;
}

.sec_video.modify-slider .swiper-button-next,
.sec_video.modify-slider .swiper-button-prev {
  background-color: rgba(255, 255, 255, 0.5);
}

.tmb_blog_slider_image > div {
  line-height: 0;
}

.video_wrapper {
  position: relative;
}

.mute_btn {
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 10;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  border: none;
  padding: 6px 10px;
  border-radius: 20px;
  cursor: pointer;
}
.mute_btn svg,
.mute_btn span {
  display: block;
}

.mute_btn span {
  width: 24px;
  height: 24px;
}

@media (hover: hover) {
  .sec_video.modify-slider:hover .tmb_blog_slider_image > .product_info_card {
    transform: translateX(0%);
    cursor: pointer;
  }
}

.swiper.active.product_info_card {
  transform: translateX(0%);
}

.sec_head {
  padding: 43px 40px 15px;
}

.sec_video {
  max-width: 1020px;
  margin: 0 auto;
}

.tmb_blog_slider_image {
  position: relative;
}

.shop_cta {
  text-align: start;
  margin-top: 12px;
}

.subtitle {
  color: #ffffff;
}

.main_heading {
  color: #ef0000;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 700;
  line-height: 69px;
  margin: 0 auto;
}

.sec_content.bg-black {
  padding: 110px 54px 110px;
  transition: 0.5s;
}

.sec_content iframe {
  max-width: 1020px;
  margin: 0 auto;
}

.sec_content.bg-black iframe {
  width: 100%;
  height: 570px;
}

.sec_image_slider {
  height: 100%;
}

.sec_image_slider img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

/* Responsive Breakpoints */
@media (max-width: 767px) {
  .sec_content.bg-black {
    padding: 80px 14px 80px;
  }

  .sec_head {
    padding: 0 13px;
  }

  .main_heading {
    font-size: 46px;
    line-height: 44px;
  }

  .sec_content.bg-black iframe {
    height: 155px;
  }

  video {
    height: auto;
  }

  .subtitle {
    margin-top: 0;
  }
}

@media (max-width: 575px) {
  .tmb_blog_slider_image .swiper-slide img {
    min-height: 520px;
    object-fit: cover;
    height: 100%;
  }

  .sec_content.bg-black {
    padding: 80px 15px 80px;
    background: transparent !important;
  }
}
</style>

<style>
/* Slider Css Code */

/* .sec_video.modify-slider .swiper-slide img{
  display: block;
  height: 100%;  
} */

body.blog.blog\.i-am .sec_video.modify-slider .shop_cta {
  display: none;
}

.sec_video.modify-slider .swiper-slide {
  height: initial;
}

.sec_video.modify-slider .swiper-button-prev,
.modify-slider .swiper-button-next {
  background-color: #fff;
}

.sec_video.modify-slider .swiper-button-prev {
  left: 5px;
}

.sec_video.modify-slider .swiper-button-next {
  right: 5px;
}

.sec_video .swiper-slide.swiper-slide .product_info_card {
  transform: translateX(0);
}

@media (max-width: 575px) {
  .shop_cta {
    margin-left: 13px;
  }
}

@media (max-width: 480px) {
  .swiper.product_info_card {
    height: 100%;
    width: 100%;
  }

  .video_sec .product_info_card {
    max-width: 100%;
    height: 100%;
    width: 100%;
  }

  .video_sec .swiper-button-next,
  .video_sec .swiper-button-prev {
    display: block !important;
  }

  .product_info_card .product_info_card a img {
    height: 266px;
    object-fit: cover;
  }
}
</style>
